<script setup>
import CustomFieldTypeRenderer from '@/components/customFields/CustomFieldTypeRenderer.vue'
import { useProjectStore } from '@/store/project'
import { useBuildingStore } from '@/store/building'
import { useFilterStore } from '@/store/filter'
import { useSortStore } from '@/store/sort'
import { usePlayerStore } from '@/store/players'

const playerStore = usePlayerStore()
const { $getI18n } = useNuxtApp()

const currentUnit = computed(() => {
    return playerStore.apartmentChooser.currentUnit
})

const props = defineProps({
    height: {
        type: [Number, String],
        required: false,
        default: () => undefined
    }
})

const emits = defineEmits(['selectUnit'])

const projectStore = useProjectStore()
const buildingStore = useBuildingStore()
const project = projectStore.projectWithFieldsAndStatuses
const buildings = buildingStore.buildings

const filtersStore = useFilterStore()

const units = computed(() => {
    return filtersStore.filteredUnits.map((u) => {
        return { ...u, ...u.customColumnValues, ...u.rowData }
    })
})

const sortStore = useSortStore()
const sort = sortStore.sort
const { setSort } = sortStore

const headers = computed(() => {
    const headers = [...projectStore.listViewFields]
        .sort((a, b) => a.orderInList - b.orderInList)
        .map(({ key: value, label: text, type, sortable }) => ({
            title: $getI18n(text),
            value,
            sortable: sortable !== 'disabled',
            sort: sortStore.getSortFunction(type)
        }))

    headers.push({
        title: '',
        value: 'route',
        sortable: false,
        align: 'end',
        class: 'route'
    })

    return headers
})

// const getHeaderType = (header) => {
//     return project.fields.find((f) => f.key === header)?.type
// }

const unitRoute = (unitId) => {
    const unit = units.value.find((u) => u.unitId === unitId)
    const building = buildings.find((b) => b.id === unit.buildingId)
    return `/${project.slug}/${building.slug}/${unitId}`
}

const selectUnit = (unit) => {
    emits('selectUnit', unit)
}

// const goToUnit = (unitId) => {
//     const unitPage = unitRoute(unitId)
//     window.history.pushState({}, '', unitPage)
//     useRouter().replace(unitPage)
// }

const sortBy = computed({
    get() {
        if (sortStore.sortBy) {
            return [{ key: sortStore.sortBy, order: sortStore.sortOrder }]
        }
        return undefined
    },
    set(e) {
        if (e.length) {
            sortStore.updateSort(e[0].key, e[0].order)
        } else {
            sortStore.updateSort()
        }
    }
})

const selectUnitAndGoToUnitPage = (unit) => {
    selectUnit(unit)
    const route = unitRoute(unit.unitId)
    if (route) {
        navigateWithHash(route)
    }
}
</script>
<template>
    <div class="all-apartments-table">
        <v-data-table
            :headers="headers"
            :items="units"
            :items-per-page="-1"
            :disable-pagination="true"
            width="100%"
            v-model:sort-by="sortBy"
            class="unit-data-table bg-grey-lighten-5"
            :mobile="false"
        >
            <template v-slot:item="{ item }">
                <tr
                    :class="{
                        'single-row': true,
                        'active-row': currentUnit && item.unitId === currentUnit.unitId
                    }"
                    @click="selectUnit(item)"
                >
                    <td v-for="(header, index) of headers" :key="index">
                        <template v-if="header.value === 'route'">
                            <div align="end">
                                <v-btn
                                    :style="{ background: project.themeColor }"
                                    class="text-capitalize"
                                    @click="selectUnitAndGoToUnitPage(item)"
                                    >{{ $t('viewApartment') }}
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <template v-else>
                            <CustomFieldTypeRenderer
                                :project="project"
                                :unit="item"
                                :fieldKey="header.value"
                            />
                        </template>
                    </td>
                </tr>
            </template>
            <template #bottom></template>
        </v-data-table>
    </div>
</template>
<style>
.v-data-table-header__content > span {
    text-transform: uppercase !important;
    color: #00000088 !important;
}
</style>
<style scoped>
.all-apartments-table {
    width: 100%;
}

.single-row {
    cursor: pointer;
}

.single-row:hover {
    background-color: rgb(13, 165, 78, 0.1);
}

.single-row.active-row {
    background-color: rgb(13, 165, 78, 0.3);
}
</style>
